/**
 * State for person
 */
export const state = {
  /**
   * Weather the add person is validated
   * true or false
   */
  validated: false,
  /**
   * Weather adding or editing the person
   * "ADD" or "EDIT"
   * Default value is "ADD"
   */
  addOrEditPerson: "ADD",
  /**
   * Stores the person id (otherevent_id)
   * Default value is 0
   */
  editPersonId: 0
};
